export const itemsUpdated = new CustomEvent('ct.itemsUpdated');
export const itemUpdated = new CustomEvent('ct.itemUpdated', { bubbles: true });
export const noItemsFound = new CustomEvent('ct.noItemsFound', { bubbles: true });
